import axios from 'axios';
import { buildAgentPath } from '../../helpers';
import { handleErrors, headerBuilder, paramBuilder, validateOptions } from '../http';
export var fetchBridges = function fetchBridges() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('fetchBridges', [], options);
  return axios.get("".concat(buildAgentPath(options), "/app/api/v1/bridges"), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      bridges: response.data.bridges
    };
  })["catch"](handleErrors);
};
export var fetchBridge = function fetchBridge() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('fetchBridge', ['bridgeSlug'], options);
  return axios.get("".concat(buildAgentPath(options), "/app/api/v1/bridges/").concat(options.bridgeSlug), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      bridge: response.data.bridge
    };
  })["catch"](handleErrors);
};
export var createBridge = function createBridge() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('createBridge', ['bridge'], options);
  return axios.post("".concat(buildAgentPath(options), "/app/api/v1/bridges/"), options.bridge, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      bridge: response.data.bridge
    };
  })["catch"](handleErrors);
};
export var updateBridge = function updateBridge() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('updateBridge', ['bridgeSlug', 'bridge'], options);
  return axios.put("".concat(buildAgentPath(options), "/app/api/v1/bridges/").concat(options.bridgeSlug), options.bridge, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      bridge: response.data.bridge
    };
  })["catch"](handleErrors);
};
export var deleteBridge = function deleteBridge() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('deleteBridge', ['bridgeSlug'], options);
  return axios["delete"]("".concat(buildAgentPath(options), "/app/api/v1/bridges/").concat(options.bridgeSlug), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      bridge: response.data.bridge
    };
  })["catch"](handleErrors);
};
export var validateBridge = function validateBridge() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('validateBridge', ['bridge'], options);
  var endpoint = buildAgentPath(options) + (options.bridgeSlug ? "/app/api/v1/bridges/".concat(options.bridgeSlug, "/validate") : "/app/api/v1/adapters/validate?type=bridge");
  return axios.post(endpoint, options.bridge, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      successMessage: response.data.message
    };
  })["catch"](handleErrors);
};